<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>주차서비스</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">주차서비스</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/prepaymentinfo" title="요금사전결제">요금사전결제</router-link></li>
            <li><router-link to="/unpaidinfo" title="미납주차요금">미납주차요금</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li class="web">
          <p class="pageTxt">정기권</p>
          <ul class="depth">
            <li><router-link to="/periodinfo" title="정기권">정기권</router-link></li>
            <li><router-link to="/webdiscountcharge" title="웹 선불권">웹 선불권</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">정기권 신청</p>
          <ul class="depth">
            <li><router-link to="/periodinfo" title="정기권 안내">정기권 안내</router-link></li>
            <li><router-link to="/periodapplication" title="정기권 신청">정기권 신청</router-link></li>
            <li><router-link to="/periodlookup" title="정기권 조회/결제">정기권 조회/결제</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">정기권 신청</h3>
        <p class="pageCaution">
          정기권 신청 및 운영에 관한 유의사항을 반드시 읽으신 후 정기권 신청해 주시기 바라며, 유의 사항 미확인 및 오기재로 인해 발생하는
          불이익은 '정기권 신청자 본인'에게 있습니다.
        </p>
        <article>
          <p class="subTitle">정기권 온라인 신청 절차</p>
          <!--periodStep-->
          <div class="periodStep web">
            <ul>
              <li class="step01">인터넷 정기권<br />발매 공고</li>
              <li class="step02">로그인</li>
              <li class="step03">정기권 신청</li>
              <li class="step04">증명서 제출<br />(대상자에 한함)</li>
              <li class="step05">대상자 확인</li>
              <li class="step06">결제</li>
            </ul>
          </div>
          <div class="periodStep mobile">
            <ul>
              <li class="step01">인터넷 정기권<br />발매 공고</li>
              <li class="step02">로그인</li>
              <li class="step03">정기권 신청</li>
              <li class="step04">결제</li>
              <li class="step05">대상자 확인</li>
              <li class="step06">증명서 제출<br />(대상자에 한함)</li>
            </ul>
          </div>
          <!--//periodStep-->
          <div class="infoBox">
            <ul class="bullet arrowType">
              <li>
                정기권은 선착순을 통해 판매가 진행되며, <strong class="point">3개월(분기별)</strong> 단위 신청 및 이용이 가능합니다.
                <span class="subNote">※ 월중 신청 시 일할계산</span>
              </li>
              <li>본인 명의의 차량 한 대만 신청이 가능하며, 월정기권 운영 주차장에 한하여 신청이 가능합니다.</li>
              <li class="caution">월정기권 신청 시 <strong class="point">차량등록증 첨부는 필수</strong>입니다.</li>
              <li class="caution">
                월정기권 별도 지정 구역 미운영하며, 주차장 만차 시 대기 발생 및 주차 불가할 수 있습니다.
              </li>
            </ul>
          </div>
        </article>
        <article>
          <!--table pc-->
          <div class="table horizontal-table web">
            <table>
              <caption>
                정기권 신청 테이블
              </caption>
              <colgroup>
                <col style="width: 15%" />
                <col style="width: 35%" />
                <col style="width: 15%" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">이름<span class="redDot">*</span></th>
                  <td>
                    <div class="flex">
                      <input type="text" v-model="waitingNm" title="이름 입력" />
                    </div>
                    <div class="error" v-if="!$v.waitingNm.required">필수 입력란입니다.</div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">주소<span class="redDot">*</span></th>
                  <td colspan="3">
                    <div class="address">
                      <div class="flex">
                        <input type="text" title="우편번호 입력" v-model="zipcode" readonly />
                        <button type="button" class="btn gray" @click="daumPostcodeBtn">우편번호</button>
                      </div>
                      <div class="error" v-if="!$v.zipcode.required">주소를 검색하세요.</div>
                      <div class="flex">
                        <input type="text" title="주소 입력" v-model="addr" readonly />
                        <input type="text" title="상세주소 입력" v-model="addrDetail" />
                      </div>
                      <!-- <div class="error" v-if="!$v.addrDetail.required">상세주소를 입력하세요.</div> -->
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">휴대폰번호<span class="redDot">*</span></th>
                  <td class="3">
                    <div class="tell">
                      <input type="text" maxlength="3" title="휴대폰 식별번호 선택" v-model="firstNum" />
                      <input type="text" maxlength="4" title="휴대폰 앞 4자리 입력" v-model="secondNum" />
                      <input type="text" maxlength="4" title="휴대폰 뒤 4자리 입력" v-model="lastNum" />
                    </div>
                    <div class="error" v-if="!$v.firstNum.required || !$v.secondNum.required || !$v.lastNum.required">
                      필수 입력란입니다.
                    </div>
                    <div
                      class="error"
                      v-if="
                        !(
                          $v.firstNum.mobileRegex &&
                          $v.secondNum.mobileRegex &&
                          $v.lastNum.mobileRegex &&
                          $v.firstNum.minLength &&
                          $v.secondNum.minLength &&
                          $v.lastNum.minLength
                        )
                      "
                    >
                      휴대폰 번호를 확인해주세요
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">신청 주차장<span class="redDot">*</span></th>
                  <td>
                    <select v-model="parking" title="신청 주차장 선택" @change="getPeriodAllotType(parking)">
                      <option :value="{ id: '', text: '' }">선택하세요.</option>
                      <option
                        v-for="(item, index) in parkingList"
                        :key="index"
                        :value="{
                          id: item.SECTN_ID,
                          text: item.PARKING_NM,
                          periodAllotType: item.PERIOD_ALLOT_TYPE,
                          useDivCd: item.PERIOD_USE_DIV_CD,
                          startDttm: item.START_DTTM,
                          endDttm: item.END_DTTM,
                        }"
                      >
                        {{ item.PARKING_NM }}
                      </option>
                    </select>
                    <div class="error" v-if="!$v.parking.required">필수 입력란입니다.</div>
                  </td>
                  <th scope="row">배정방식</th>
                  <td>{{ periodAllotType }}</td>
                </tr>
                <tr>
                  <th scope="row">주차구분<span class="redDot">*</span></th>
                  <td>
                    <select v-model="useDivCd" id="" title="주차구분 선택">
                      <option value="">선택</option>
                      <option v-if="useDivShow == 'UTM-001'" value="UTM-001">주야간</option>
                      <option v-if="useDivShow == 'UTM-001' || useDivShow == 'UTM-002'" value="UTM-002">주간</option>
                      <option v-if="useDivShow == 'UTM-001' || useDivShow == 'UTM-003'" value="UTM-003">야간</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th scope="row">차량번호<span class="redDot">*</span></th>
                  <td>
                    <input type="text" v-model="carNo" title="차량번호 입력" />
                  </td>
                  <th scope="row">차량 소유주명<span class="redDot">*</span></th>
                  <td>
                    <input type="text" title="차량 소유주명 입력" v-model="carOwnerNm" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">차량등록증<span class="redDot">*</span></th>
                  <td colspan="3">
                    <div class="flex">
                      <div class="fileArea">
                        <p class="upload-name">{{ carRegFileName }}</p>
                        <input
                          type="file"
                          class="hidden"
                          id="carRegFileWeb"
                          @change="changeCarRegFile"
                          @click="clearFileInput"
                        />
                        <label for="carRegFileWeb" class="btn gray">파일첨부</label>
                      </div>
                    </div>
                    <div class="error" v-if="!carRegFile">필수 첨부 항목입니다.</div>
                    <p class="info">첨부파일 (최대용량:20M) *이미지 파일 (jpg, jpeg, gif, png, pdf)</p>
                  </td>
                </tr>
                <tr>
                  <th scope="row">할인자격<span class="redDot">*</span></th>
                  <td colspan="3">
                    <div class="flex">
                      <input v-model="discountNm" type="text" class="middle" readonly />
                      <button :disabled="isLoading" v-if="isLoading" class="btn gray"><LoadingSpinner /></button>
                      <button
                        :disabled="isLoading"
                        v-if="!isLoading"
                        type="button"
                        class="btn gray"
                        @click="checkIrs('notFinal')"
                      >
                        할인적용확인
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">할인자격 변경<span class="redDot">*</span></th>
                  <td colspan="3">
                    <div class="flex">
                      <select v-model="discountCg" title="할인자격 변경" class="middle">
                        <option
                          v-for="(item, index) in discountCgList"
                          :key="index"
                          :value="{ id: item.code, text: item.codeNm }"
                        >
                          {{ item.codeNm }}
                        </option>
                      </select>
                      <div v-if="discountCg != '' && discountCg.id != 'DC001'" class="fileArea">
                        <p class="upload-name">{{ firstName }}</p>
                        <input
                          type="file"
                          class="hidden"
                          id="file"
                          ref="files"
                          @change="changeFile"
                          @click="resetFile"
                        />
                        <label for="file" class="btn gray">파일첨부</label>
                      </div>
                    </div>
                    <p class="info">첨부파일 (최대용량:20M) *이미지 파일 (jpg, jpeg, gif, png, pdf)</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--//table pc-->

          <!--table mobile-->
          <div class="table horizontal-table mobile">
            <table>
              <caption>
                정기권 신청 테이블
              </caption>
              <colgroup>
                <col style="width: 35%" />
                <col style="width: 65%" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">이름<span class="redDot">*</span></th>
                  <div><input type="text" v-model="waitingNm" title="이름 입력" /></div>
                  <div class="error" v-if="!$v.waitingNm.required">필수 입력란입니다.</div>
                </tr>
                <tr>
                  <th scope="row">주소<span class="redDot">*</span></th>
                  <td>
                    <div class="address">
                      <div class="flex">
                        <input type="text" title="우편번호 입력" v-model="zipcode" readonly />
                        <button type="button" class="btn gray" @click="daumPostcodeBtn">우편번호</button>
                      </div>
                      <div class="flex">
                        <input type="text" title="주소 입력" v-model="addr" readonly />
                        <input type="text" title="상세주소 입력" v-model="addrDetail" />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">휴대폰번호<span class="redDot">*</span></th>
                  <td>
                    <div class="tell">
                      <input type="text" maxlength="3" title="휴대폰 식별번호 선택" v-model="firstNum" />
                      <input type="text" maxlength="4" title="휴대폰 앞 4자리 입력" v-model="secondNum" />
                      <input type="text" maxlength="4" title="휴대폰 뒤 4자리 입력" v-model="lastNum" />
                    </div>
                    <div class="error" v-if="!$v.firstNum.required || !$v.secondNum.required || !$v.lastNum.required">
                      필수 입력란입니다.
                    </div>
                    <div
                      class="error"
                      v-if="
                        !(
                          $v.firstNum.mobileRegex &&
                          $v.secondNum.mobileRegex &&
                          $v.lastNum.mobileRegex &&
                          $v.firstNum.minLength &&
                          $v.secondNum.minLength &&
                          $v.lastNum.minLength
                        )
                      "
                    >
                      휴대폰 번호를 확인해주세요
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">신청 주차장<span class="redDot">*</span></th>
                  <td>
                    <select v-model="parking" title="신청 주차장 선택" @change="getPeriodAllotType(parking)">
                      <option :value="{ id: '', text: '' }">선택하세요.</option>
                      <option
                        v-for="(item, index) in parkingList"
                        :key="index"
                        :value="{
                          id: item.SECTN_ID,
                          text: item.PARKING_NM,
                          periodAllotType: item.PERIOD_ALLOT_TYPE,
                          useDivCd: item.PERIOD_USE_DIV_CD,
                          startDttm: item.START_DTTM,
                          endDttm: item.END_DTTM,
                        }"
                      >
                        {{ item.PARKING_NM }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th scope="row">배정방식</th>
                  <td>선착순</td>
                </tr>
                <tr>
                  <th scope="row">주차구분<span class="redDot">*</span></th>
                  <td>
                    <select v-model="useDivCd" id="" title="주차구분 선택">
                      <option value="">선택</option>
                      <option v-if="useDivShow == 'UTM-001'" value="UTM-001">주야간</option>
                      <option v-if="useDivShow == 'UTM-001' || useDivShow == 'UTM-002'" value="UTM-002">주간</option>
                      <option v-if="useDivShow == 'UTM-001' || useDivShow == 'UTM-003'" value="UTM-003">야간</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th scope="row">차량번호<span class="redDot">*</span></th>
                  <td>
                    <input type="text" v-model="carNo" title="차량번호 입력" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">차량 소유주명<span class="redDot">*</span></th>
                  <td>
                    <input type="text" title="차량 소유주명 입력" v-model="carOwnerNm" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">차량등록증<span class="redDot">*</span></th>
                  <td>
                    <div class="fileArea">
                      <p class="upload-name">{{ carRegFileName }}</p>
                      <input
                        type="file"
                        class="hidden"
                        id="carRegFileMobile"
                        @change="changeCarRegFile"
                        @click="clearFileInput"
                      />
                      <label for="carRegFileMobile" class="btn gray">파일첨부</label>
                    </div>
                    <div class="error" v-if="!carRegFile">필수 첨부 항목입니다.</div>
                    <p class="info">첨부파일 (최대용량:20M) *이미지 파일 (jpg, jpeg, gif, png, pdf)</p>
                  </td>
                </tr>
                <tr>
                  <th scope="row">할인자격<span class="redDot">*</span></th>
                  <td colspan="3">
                    <div class="flex wrap">
                      <input v-model="discountNm" type="text" class="middle" readonly />
                      <button :disabled="isLoading" v-if="isLoading" class="btn gray"><LoadingSpinner /></button>
                      <button
                        :disabled="isLoading"
                        v-if="!isLoading"
                        type="button"
                        class="btn gray"
                        @click="checkIrs('notFinal')"
                      >
                        할인적용확인
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">할인자격 변경<span class="redDot">*</span></th>
                  <td colspan="3">
                    <div class="flex" style="flex-direction: column">
                      <select v-model="discountCg" title="할인자격 변경" class="middle">
                        <option
                          v-for="(item, index) in discountCgList"
                          :key="index"
                          :value="{ id: item.code, text: item.codeNm }"
                        >
                          {{ item.codeNm }}
                        </option>
                      </select>
                      <div v-if="discountCg != '' && discountCg.id != 'DC001'" class="fileArea">
                        <p class="upload-name">{{ firstName }}</p>
                        <input
                          type="file"
                          class="hidden"
                          id="file"
                          ref="files"
                          @change="changeFile"
                          @click="resetFile"
                        />
                        <label for="file" class="btn gray">파일첨부</label>
                      </div>
                    </div>
                    <p class="info">첨부파일 (최대용량:20M) *이미지 파일 (jpg, jpeg, gif, png, pdf)</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--//table mobile-->
        </article>

        <!--privacyArea-->
        <article class="privacyArea">
          <article class="privacyHead">
            <p class="tit">개인정보 수집·이용 동의</p>
            <p class="checkbox btnCheck">
              <input
                type="checkbox"
                id="chk-all"
                class="hidden"
                v-model="allCheck"
                @click="checkAll"
                @change="checkboxCkc()"
              />
              <label for="chk-all" class="btn checkBtn">전체동의</label>
            </p>
          </article>

          <article>
            <Accordion class="accordion type01">
              <template #title>개인정보 수집·이용 동의</template>
              <template #cont>
                이천시시설관리공단(이하 "공단")은 고객의 개인정보를 중요시 하며, 공영주차장 웹선불권 및 웹할인권 이용·관리를 위하여 「개인정보보호법」 제15조, 제17조 및 제22조에 따라 아래와 같이 귀하의 개인정보 수집·이용 및 제공에 관한 동의를 얻고자 합니다.<br />
                다음의 사항에 대해 자세히 읽어 보신 후, 동의 여부를 체크, 서명하여 주십시오.<br /><br />
                
                <strong>■ 개인정보 수집·이용 동의</strong><br />
                <strong>1. 개인정보 수집·이용 목적</strong><br />
                ○ 공영주차장 월 정기권 이용 관리(차량변경 포함)<br />
                ○ 공영주차장 월 정기권 이용 시 증빙서류보존 목적<br /><br />
                
                <strong>2. 수집하는 개인정보 항목</strong><br />
                ○ 신청자 항목 : 성명, 생년월일, 전화번호, 차량번호, 차량명<br />
                ○ 차량변경 시 차량 소유주를 확인하여 개인정보를 추가 수집할 수 있음을 알려드립니다.<br /><br />
                
                <strong>3. 보유 및 이용기간</strong><br />
                ○ 개인정보 보호법에 의거 법률로 정한 목적 이외의 다른 어떠한 목적으로도 사용되지 않으며 내부 규정에 의해 일정 기간(등록일로부터 5년) 저장된 후 파기<br />
                (※ 다른 법률에 따라 보존하여야 하는 경우 해당 법률에 따름)<br /><br />
                
                귀하는 개인정보 수집·이용에 동의를 거부할 수 있습니다. 다만, 이에 대한 동의를 하시지 않을 경우에는 공영주차장 월정기권 신청 및 이용 등 서비스 제공이 불가능할 수 있음을 알려 드립니다.
              </template>
            </Accordion>
            <p class="checkbox">
              <input type="checkbox" id="chk-privacy1" class="hidden" v-model="privacyCheck1" @change="checkboxCkc()" />
              <label for="chk-privacy1" class="btn"> 동의함 </label>
            </p>
          </article>

          <article>
            <Accordion class="accordion type01">
              <template #title>민감정보(장애등급, 국가유공자정보 등) 수집·이용 동의</template>
              <template #cont>
                <strong>■ 민감정보(장애등급, 국가유공자정보 등) 수집·이용 동의</strong><br />
                ○ 민감정보 수집·이용 목적: 월정기권 요금 감면 등 이용대상자 관리<br />
                ○ 민감정보(장애등급, 국가유공자정보 등)에 대하여 「개인정보보호법」 제23조에 따라 상기 명시된 사항을 위하여 수집·처리할 수 있습니다.<br />
                ○ 민감정보 보유 및 이용기간: 개인정보 보호법에 의거 법률로 정한 목적 이외의 다른 어떠한 목적으로도 사용되지 않으며 내부 규정에 의해 일정 기간(등록일로부터 5년) 저장된 후 파기<br />
                &nbsp;&nbsp;&nbsp;(※ 다른 법률에 따라 보존하여야 하는 경우 해당 법률에 따름)<br /><br />
                
                ※ 귀하는 개인정보 수집·이용에 동의를 거부할 수 있습니다. 다만, 이에 대한 동의를 하시지 않을 경우에는 주차요금 환급 및 월정기권 해지신청 등 서비스 제공이 불가능할 수 있음을 알려 드립니다.
              </template>
            </Accordion>
            <p class="checkbox">
              <input type="checkbox" id="chk-privacy2" class="hidden" v-model="privacyCheck2" @change="checkboxCkc()" />
              <label for="chk-privacy2" class="btn"> 동의함 </label>
            </p>
          </article>
        </article>
        <!--//privacyArea-->

        <article class="btnArea">
          <button type="button" class="btn gray" @click="$router.push('/periodinfo')">취소</button>
          <button type="button" class="btn blue" :disabled="isLoading" @click="periodApplication">확인</button>
        </article>
      </div>
    </section>

    <zip-code-modal v-if="isZipcodeModal">
      <template #info> 우편번호 </template>
      <template #content>
        <article>
          <VueDaumPostcode @complete="searchedAddress" />
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CancleBtn"><span class="hidden">닫기</span></button>
      </template>
    </zip-code-modal>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import ZipCodeModal from '../../../components/PopupType1.vue';
import { VueDaumPostcode } from 'vue-daum-postcode';
import { required, minLength, helpers, or } from 'vuelidate/lib/validators';
import LoadingSpinner from '../../../components/LoadingSpinner.vue';
import parkingMap from "../parking/ParkingMap.vue";
import Accordion from '../../../components/Accordion01.vue';
const carNoRegex = /^\s*([가-히]{2}){0,1}\s*[0-9]{2,3}[\s]*[가-히]{1}[\s]*[0-9]{4}\s*$/gi;
const carNoRegexDipl = /^\s*([외교,영사,준외,협정,국기,준영,대표]{2}){0,1}\s*[0-9]{3}[\s]*[-]{1}[\s]*[0-9]{3}\s*$/gi;

const mobileRegex = helpers.regex('mobileRegex', /\d$/);

const MAX_FILE_SIZE = 20000000; // 20MB
const ALLOWED_FILE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/jpg',
  'image/pdf',
  'application/pdf',
];

export default {
  data() {
    return {
      parkingList: [],
      parking: {id: '', text: ''},
      periodAllotType: '주차장을 선택해주세요.',
      isZipcodeModal: false,

      waitingNm: '',
      carOwnerNm: '',
      carNo: '',
      zipcode: '',
      addr: '',
      addrDetail: '',
      firstNum: '',
      secondNum: '',
      lastNum: '',
      useDivCd: '',

      discountCd: '',
      discountNm: '',
      discountList: [],
      discountCg: '',
      discountCgList: [],
      firstName: '',

      eFiles: '',
      carRegFile: '',
      carRegFileName: '',
      afterCheckIrs: false,
      isLoading: false,
      useDivShow: '',

      startDttm: '',
      endDttm: '',
      allCheck: false,
      privacyCheck1: false,
      privacyCheck2: false,
    };
  },

  components: {
    ZipCodeModal,
    VueDaumPostcode,
    LoadingSpinner,
    Accordion,
  },

  validations: {
    waitingNm: {
      required,
    },
    parking: {
      required,
    },
    carOwnerNm: {
      required,
    },
    // discountCd: {
    // 	required
    // },
    zipcode: {
      required,
    },
    addr: {
      required,
    },
    // addrDetail: {
    //     required
    // },
    firstNum: {
      required,
      minLength: minLength(3),
      mobileRegex,
    },
    secondNum: {
      required,
      minLength: minLength(3),
      mobileRegex,
    },
    lastNum: {
      required,
      minLength: minLength(3),
      mobileRegex,
    },
    useDivCd: {
      required,
    },
    privacyCheck1: {
      required,
    },
    privacyCheck2: {
      required,
    },
  },

  mounted() {
    this.empInfoSet();
    this.getParkingList();
  },

  methods: {
    searchedAddress(data) {
      this.zipcode = data.zonecode;
      if (data.userSelectedType == 'R') {
        this.addr = data.address;
      } else {
        this.addr = data.jibunAddress;
      }
      this.isZipcodeModal = false;
    },

    getPeriodAllotType(parking) {
      if (this.useDivCd != '') {
        this.useDivCd = '';
      }
      this.useDivShow = parking.useDivCd;

      this.startDttm = parking.startDttm;
      this.endDttm = parking.endDttm;
      
      switch (parking.periodAllotType) {
        case 'RAFFLE':
          this.periodAllotType = '추첨제';
          break;
        case 'FCOME':
          this.periodAllotType = '선착순';
          break;
        default:
          this.periodAllotType = '주차장을 선택해주세요.';
          break;
      }
    },

    async periodApplication() {
      const carNo = this.carNo ? this.carNo.replace(/\s/gi, '') : '';

      if (this.$v.$invalid) {
        if (carNo == '' || !(carNoRegex.test(carNo) || carNoRegexDipl.test(carNo))) {
          alert('차량번호를 형식에 맞게 적어주세요');
        } else {
          alert('필수 항목(*)을 모두 채워주세요');
        }
        return;
      }
      if (!this.carRegFile) {
        alert('차량등록증은 필수 첨부 항목입니다.');
        return;
      }
      if (!this.privacyCheck1 || !this.privacyCheck2) {
        alert('개인정보 동의는 필수 항목입니다.');
        return;
      }
      if (await this.checkIrs('final')) {
        await this.applicationPeriod();
      }
    },

    async checkIrs(clickBtn) {
      if (this.discountCg.id != 'DC001' && this.eFiles == '' && this.discountCg != '') {
        alert('할인변경 신청시에는 증빙자료를 첨부해주세요.');
        return false;
      }
      if (clickBtn == 'final') {
        if (this.discountCd != '') return true;
      }

      const apiParams = new Map();
      apiParams.set('carNo', this.carNo.replace(/\s/gi, ''));
      apiParams.set('carOwnerNm', this.carOwnerNm);

      this.isLoading = true;
      const res = await axios('get', '/api/reduction/irs.json', Object.fromEntries(apiParams));
      this.isLoading = false;

      const data = res.data.value.dcList;

      if (data.length == 0) {
        alert('할인 조회 결과 일반으로 적용됩니다.');
        this.discountCd = 'DC001';
        this.discountNm = '일반';
      } else {
        this.discountCd = data[0].dcCode;
        this.discountNm = data[0].note;
      }
      this.afterCheckIrs = true;
      return true;
    },

    async checkTime() {
      const nowDate = new Date();
      const apiParams = new FormData();
      apiParams.append('sectnId', this.parking.id);
      apiParams.append('nowDate', this.nowDate);
      const res = await axios('post', '/api/period/checkTime.json', apiParams);
      const data = res.data.value;
      if (data != null) {
        if (data.END_DTTM < nowDate) {
          alert(data.PARKING_NM + ' 주차장의 정기권 신청시간이 마감되었습니다.');
        }
      }
    },

    async applicationPeriod() {
      const telNo = this.firstNum + this.secondNum + this.lastNum;

      const params = {
        waitingNm: this.waitingNm,
        zipcode: this.zipcode,
        addr: this.addr,
        addrDetail: this.addrDetail,
        telNo: telNo,
        sectnNm: this.parking.text,
        sectnId: this.parking.id,
        carOwnerNm: this.carOwnerNm,
        carNo: this.carNo.replace(/\s/gi, ''),
        discountCd: this.discountCd,
        discountNm: this.discountNm,
        discountCg: this.discountCg,
        periodAllotTypeKor: this.periodAllotType,
        periodAllotType: this.parking.periodAllotType,
        useDivCd: this.useDivCd,
        startDttm: this.startDttm,
        endDttm: this.endDttm,
      };

      if (this.eFiles != ('' || undefined)) {
        params.eFiles = this.eFiles;
      }

      params.carRegFile = this.carRegFile;
      params.carRegFileName = this.carRegFileName;
      this.$router.push({
        name: 'periodresult',
        params: { data: params },
      });
    },

    changeFile(e) {
      const file = e.target.files[0];

      if (!this.validateFile(file)) {
        this.resetFile();
        return;
      }

      this.firstName = file.name;
      this.eFiles = file;
    },

    // 차량등록증 첨부 (필수)
    changeCarRegFile(e) {
      const file = e.target.files[0];

      if (!this.validateFile(file)) {
        e.target.value = '';
        return;
      }

      this.carRegFileName = file.name;
      this.carRegFile = file;
    },

    // 동일 파일 재선택이 가능하도록 다이얼로그를 열기 전 input 값을 비운다.
    clearFileInput(e) {
      e.target.value = '';
    },

    validateFile(file) {
      if (!file) {
        return false;
      }

      if (file.size > MAX_FILE_SIZE) {
        alert('최대 20mb까지 업로드할 수 있습니다.');
        return false;
      }

      if (!ALLOWED_FILE_TYPES.includes(file.type)) {
        alert('이미지 파일(jpg, jpeg, gif, png, pdf)만 첨부할 수 있습니다.');
        return false;
      }

      return true;
    },

    resetFile() {
      this.$refs.files.value = '';
      this.eFiles = [];
    },

    initEFiles() {
      if (this.eFiles.length == 0) {
        this.eFiles = '';
      }
    },

    empInfoSet() {
      this.waitingNm = this.$store.state.empNm;
      this.carOwnerNm = this.$store.state.empNm;
      this.carNo = this.$store.state.empCarNo ? this.$store.state.empCarNo.replace(/\s/gi, '') : '';
      this.zipcode = this.$store.state.zipcode;
      this.addr = this.$store.state.addr;
      this.addrDetail = this.$store.state.addrDetail;
      if (!this.$store.state.empMobile) {
        return;
      }
      this.firstNum = this.$store.state.empMobile.substr(0, 3);
      this.secondNum = this.$store.state.empMobile.substr(3, 4);
      this.lastNum = this.$store.state.empMobile.substr(7);
    },
    async getParkingList() {
      const res = await axios('get', '/api/period/getParkingAndDiscountList.json');
      const data = res.data;
      this.parkingList = data.parkingList.filter(v => v.PERIOD_CELL_CNT != '0');
      this.discountList = data.discountList;
      this.discountCgList = data.discountCgList;
      this.discountCg = { id: data.discountCgList[0].code, text: data.discountCgList[0].codeNm };
    },
    CancleBtn() {
      this.isZipcodeModal = false;
    },
    daumPostcodeBtn() {
      this.isZipcodeModal = true;
    },

    checkboxCkc() {
      if (this.privacyCheck1 == true && this.privacyCheck2 == true) {
        this.allCheck = true;
        return;
      }
      this.allCheck = false;
    },

    checkAll() {
      if (this.allCheck == false) {
        this.privacyCheck1 = true;
        this.privacyCheck2 = true;
        return;
      }
      this.privacyCheck1 = false;
      this.privacyCheck2 = false;
    },
  },
};
</script>
